import ActionType from '../actions/ActionType'

export default (state = '', action) => {
  switch (action.type) {
    case ActionType.Editor.CHANGE:
      return action.payload
    case ActionType.Email.SEND_SUCCESS:
      return ''
    case ActionType.Inbox.SELECT_CONVERSATION:
      return ''
    default:
      return state
  }
}
